import { Component, OnInit, Input } from '@angular/core'
import { ACLService } from '@delon/acl'
import { MenuService, _HttpClient, SettingsService } from '@delon/theme'
import { ArrayService } from '@delon/util/array'
import { environment } from '@env/environment'
import { AuthService } from '@shared/service/auth.service'
import { initMenuTrees } from '@utils/common'
import { NzModalRef } from 'ng-zorro-antd/modal'
import { lastValueFrom } from 'rxjs'
const { msUrl } = environment.api
@Component({
  selector: 'app-support-welcome',
  templateUrl: './welcome.component.html',
})
export class SupportWelcomeComponent implements OnInit {
  @Input() record: any
  constructor(
    private http: _HttpClient,
    private ref: NzModalRef,
    private menuService: MenuService,
    private aclService: ACLService,
    private arrayService: ArrayService,
    private settingService: SettingsService,
    private authService: AuthService,
  ) {}

  ngOnInit(): void {}

  async refreshMenus(): Promise<any> {
    initMenuTrees(this.http, this.arrayService, (tree: any) => {
      this.authService.setOwnedRoutersWithParams(tree)
      this.menuService.clear()
      this.menuService.add([
        {
          group: false,
          hideInBreadcrumb: true,
          children: [...this.arrayService.arrToTree(tree)],
        },
      ])
    })
  }

  async refreshUser(): Promise<any> {
    const userData$ = this.http.get(`${msUrl.auth}/users/info`)
    const res = await lastValueFrom(userData$)
    const { data } = res as any
    const { currentTenant: tenantId, permissions = [] } = data
    this.settingService.setUser({ ...data, tenantId })
    this.aclService.set({ role: [...(permissions ?? []), 'exception'] })
  }

  async ok(): Promise<any> {
    const userData$ = this.http.get(`${msUrl.auth}/users/info`)
    const res = await lastValueFrom(userData$)
    const { data } = res
    const { company: name, nickName: contactName, mobile: contactPhone } = data

    this.http
      .post(`${msUrl.core}/company`, { name, contactName, contactPhone })
      .subscribe((res) => {
        this.refreshMenus()
        this.refreshUser()
        this.ref.close(this.record)
      })
  }
}
